module.exports = __webpack_public_path__ + "media/components/assets/sujung_13-b1aa43ac91ed6a8a01f6ba6b936c8e89.png";